import { createUseStyles } from 'react-jss';
import color from 'color';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    stepNameActive: {},

    modal: {
        width: 'min(1000px, calc(100vw - 32px))',
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: 'calc(100dvh - 32px)',
        fallbacks: { maxHeight: 'calc(100vh - 32px)' },
        overflow: 'auto',
        fontFamily: theme.font.primary,
        boxShadow: theme.isDark
            ? '0 8px 40px rgba(0,0,0,0.6)'
            : '0 8px 40px rgba(60,40,120,0.13)',
    },

    modalContainer: {
        height: 'min(600px, calc(100dvh - 32px))',
        fallbacks: { height: 'min(600px, calc(100vh - 32px))' },
        width: '100%',
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        minHeight: 0,
    },

    modalHeader:{
        height: '70px',
        display: 'flex',
        padding: '24px',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'stretch',
        borderBottom: `2px solid ${theme.colors.border_subtle}`,
        fontSize: '21px',
        fontFamily: theme.font.primary,
        color: theme.colors.text_heading,
        background: theme.colors.surface_page,
        fontWeight: 600,
    },

    imageContainer:{
        display: 'flex',
        width: 32,
        height: 32,
        padding: '0 8px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        borderRadius: 4,

        '& img':{
            // marginRight: theme.spacing(2),
            width: 22,
            height: 22,

            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
                cursor: 'pointer',
            },
        },
    },

    modalBody:{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },

    contentLeft:{
        display: 'flex',
        width: '40%',
        minWidth: 0,
        height: '100%',
        padding: '24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '24px',
        borderRight: `1px solid ${theme.colors.border_subtle}`,
        overflowY: 'auto',
        boxSizing: 'border-box',
        background: theme.colors.surface_page,

        '& p':{
            fontFamily: theme.font.secondary,
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: 'normal',
            color: theme.colors.text_heading,
        },
    },

    stepDataHeader:{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '8px',
        flexWrap: 'wrap',
    },
    timeContainer:{
        display: 'flex',
        height: '24px',
        padding: '8px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '4px',
        background: theme.colors.tab_white,

        '& p':{
            fontFamily: theme.font.secondary,
            color: theme.colors.text_heading,
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
        },
    },
    timeIcon:{
        width: '16px',
        height: '16px',
        filter: theme.isDark ? 'brightness(0) invert(0.8)' : 'none',
    },
    averageTimeContainer:{
        display: 'flex',
        height: '24px',
        padding: '8px',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '4px',
        background: theme.colors.tab_white,
        fontFamily: theme.font.secondary,
        fontSize: '14px',
        fontStyle: 'normal',
        lineHeight: 'normal',
        color: theme.colors.text_heading,

        '& b':{
            fontWeight: 'bold',
        },
    },
    errorsCounterContainer:{
        display: 'flex',
        height: '24px',
        padding: '8px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '4px',
        background: theme.colors.error_bg,

        '& img':{
            width: '16px',
            height: '16px',
        },

        '& p':{
            fontFamily: theme.font.secondary,
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
            color: theme.colors.text_heading,
        },
    },

    stepMetaContainer: {
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
    },

    stepMetaChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 10px',
        borderRadius: '999px',
        background: theme.colors.surface_elevated,
        border: `1px solid ${theme.colors.border_subtle}`,
        boxShadow: theme.isDark ? 'none' : '0 1px 3px rgba(60,40,120,0.07)',

        '& span': {
            fontFamily: theme.font.secondary,
            fontSize: '13px',
            fontWeight: 500,
            color: theme.colors.text_heading,
        },
    },

    voiceRecordingContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
        alignSelf: 'stretch',
    },
    voiceRecordingLabel:{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        alignSelf: 'stretch',

        '& p':{
            color: theme.colors.text_heading,
            fontFamily: theme.font.primary,
            fontSize: '18px',
            fontWeight: '400',
        },
    },
    voiceRecording:{
        display: 'flex',
        width: '100%',
        padding: '12px',
        alignItems: 'center',
        gap: '12px',
        borderRadius: '4px',
        background: theme.colors.surface_page,
    },
    audioPlayer: {
        width: '100%',
        minWidth: 0,
    },

    videoContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
        alignSelf: 'stretch',
    },
    videoHeader:{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        alignSelf: 'stretch',

        '& p':{
            fontFamily: theme.font.secondary,
            color: theme.colors.text_heading,
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
        },
    },
    video:{
        height: '180px',
    },
    noMediaPresent:{
        width: '100%',
        textAlign: 'center',
        fontFamily: theme.font.secondary,
        fontStyle: 'italic',
    },

    contentRight:{
        display: 'flex',
        width: '60%',
        minWidth: 0,
        height: '100%',
        padding: '24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '24px',
        flex: '1 0 0',
        alignSelf: 'stretch',
        overflow: 'hidden',
        boxSizing: 'border-box',
        background: theme.colors.surface_elevated,

        '& p':{
            fontFamily: theme.font.primary,
            fontSize: '18px',
            fontWeight: '600',
            color: theme.colors.text_heading,
        },
    },
    eventsWrapper:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
        alignSelf: 'stretch',
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
    },
    eventContainer:{
        display: 'flex',
        padding: '16px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        background: theme.colors.surface_page,
        border: `1px solid ${theme.colors.border_subtle}`,
        boxShadow: theme.isDark
            ? '0 2px 8px rgba(0,0,0,0.35)'
            : '0 2px 8px rgba(60,40,120,0.07)',
    },
    errorEventContainer: {
        background: 'rgba(229, 74, 74, 0.14)',
        border: `1px solid ${color(theme.colors.red).fade(0.5).string()}`,
        boxShadow: theme.isDark
            ? '0 2px 8px rgba(200,50,50,0.18)'
            : '0 2px 8px rgba(220,60,60,0.10)',
    },
    eventHedaer:{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'stretch',
        fontFamily: theme.font.secondary,

        '& b':{
            fontSize: '18px',
            fontWeight: '700',
            color: theme.colors.text_heading,
            lineHeight: "normal",
        },
        '& p':{
            fontSize: '14px',
            fontWeight: '400',
            color: theme.colors.grey_text,
            lineHeight: "normal",
        },
    },
    errorEventHeader: {
        '& b': {
            color: theme.colors.deep_red,
        },
    },
    eventDescription:{
        alignSelf: 'stretch',
        fontFamily: theme.font.secondary,

        '& p':{
            fontSize: '16px',
            fontWeight: '400',
            color: theme.colors.text_heading,
            lineHeight: "normal",
        },
    },
    eventActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignSelf: 'stretch',
    },
    detailsToggle: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 30,
        padding: '0 12px',
        borderRadius: 999,
        border: `1px solid ${color(theme.colors.violet_primary).fade(0.72).string()}`,
        background: 'rgba(95, 75, 139, 0.08)',
        color: theme.colors.violet_primary,
        fontFamily: theme.font.secondary,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 0.2,
        cursor: 'pointer',
    },
    eventValuePanel: {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 10,
        paddingTop: 4,
    },
    eventValueCard: {
        display: 'flex',
        minHeight: 68,
        padding: '10px 12px',
        flexDirection: 'column',
        gap: 6,
        borderRadius: 10,
        border: `1px solid ${theme.colors.border_subtle}`,
        background: theme.colors.surface_elevated,
        boxShadow: theme.isDark ? '0 2px 8px rgba(0,0,0,0.35)' : `0 8px 18px ${theme.colors.border_subtle}`,
    },
    eventValueLabel: {
        color: theme.colors.text_muted_purple,
        fontFamily: theme.font.secondary,
        fontSize: 10,
        fontWeight: 700,
        lineHeight: 1.2,
        letterSpacing: 0.7,
        textTransform: 'uppercase',
    },
    eventValueText: {
        color: theme.colors.text_heading,
        fontFamily: theme.font.secondary,
        fontSize: 13,
        fontWeight: 700,
        lineHeight: 1.35,
        wordBreak: 'break-word',
    },
    placeholder:{
        fontStyle: 'italic',
        color: theme.colors.grey_text,
    },

    [theme.down('tablet')]: {
        modal: {
            overflowY: 'auto',
        },
        modalContainer: {
            height: 'auto',
            minHeight: 'calc(100dvh - 16px)',
            fallbacks: { minHeight: 'calc(100vh - 16px)' },
        },
        modalHeader: {
            padding: '16px',
            fontSize: '18px',
        },
        modalBody: {
            flexDirection: 'column',
            minHeight: 'auto',
            overflowY: 'visible',
        },
        contentLeft: {
            width: '100%',
            height: 'auto',
            borderRight: 0,
            borderBottom: `1px solid ${theme.colors.border_subtle}`,
            overflowY: 'visible',
        },
        contentRight: {
            width: '100%',
            height: 'auto',
            overflow: 'visible',
        },
        eventsWrapper: {
            overflowY: 'visible',
        },
    },
}));
